export default __webpack_public_path__ + "static/media/480_dummy2016-hilfsprojekt01-de.b28a6678.png";